/**
 * DE registration form — phone field behaviour:
 * - Only digits (0–9) and a leading '+' are allowed; all other characters are stripped
 * - '+' is allowed as the first character only; auto-prepended when the user omits it
 * - Maximum 15 digits (excluding '+'); minimum 9 digits when the field is populated
 * - Field is optional — validation applies only when a value is present
 * - No spaces or separators permitted
 */
(function ($) {
    /** Maximum number of digits allowed after the '+' sign */
    var MAX_DIGITS = 15;

    /**
     * Sanitize the raw input value:
     *   1. Strip every character that is not a digit or a leading '+'
     *   2. Auto-prepend '+' when the value starts with a digit
     *   3. Enforce the 15-digit maximum (excluding '+')
     * @param {string} raw - Raw value from the input element
     * @returns {string} - Sanitized phone string
     */
    function sanitize(raw) {
        // Remove everything that is not a digit or '+'
        var cleaned = raw.replace(/[^0-9+]/g, '');

        // Strip any '+' that appears after the first character
        cleaned = cleaned.replace(/^(\+?)(.*)$/, function (match, plus, rest) {
            return plus + rest.replace(/\+/g, '');
        });

        // Auto-prepend '+' if the value starts with a digit
        if (cleaned.length && cleaned.charAt(0) !== '+') {
            cleaned = '+' + cleaned;
        }

        // Enforce max length: '+' plus up to MAX_DIGITS digits
        var digits = cleaned.slice(1); // everything after '+'
        if (digits.length > MAX_DIGITS) {
            cleaned = '+' + digits.slice(0, MAX_DIGITS);
        }

        return cleaned;
    }

    /**
     * Validate the phone field value.
     * Returns true if empty (phone is optional).
     * Otherwise validates against ^\+[0-9]{9,15}$.
     * @param {jQuery} $field - jQuery-wrapped phone input
     * @returns {boolean} - Whether the phone value is valid
     */
    function isPhoneValid($field) {
        var val = $field.val();
        if (!val) {
            return true;
        }
        // Use pattern attr rendered from profile.xml regexp, fall back to the agreed rule
        var patternAttr = $field.attr('pattern') || '^\\+[0-9]{9,15}$';
        return new RegExp(patternAttr).test(val);
    }

    /**
     * Toggle the invalid state and error message for the phone field.
     * @param {jQuery} $field - jQuery-wrapped phone input
     * @param {boolean} valid - Whether the current value is valid
     */
    function setPhoneValidity($field, valid) {
        var $error = $('#form-phone-error');
        var errorText = $field.data('range-error') || $field.data('pattern-mismatch') || '';
        if (valid) {
            $field.removeClass('is-invalid');
            $error.text('');
        } else {
            $field.addClass('is-invalid');
            $error.text(errorText);
        }
    }

    $(document).ready(function () {
        var $phoneField = $('#registration-form-phone');

        if (!$phoneField.length) {
            return;
        }

        // Sanitize on every keystroke / paste — strips invalid chars, enforces max length,
        // auto-prepends '+'. Cursor position is preserved by reading selectionStart first.
        $phoneField.on('input', function () {
            var $el = $(this);
            var el = this;
            var caretPos = el.selectionStart;
            var before = $el.val();
            var after = sanitize(before);

            if (before !== after) {
                // Adjust caret: account for any characters removed before the cursor
                var removed = before.length - after.length;
                $el.val(after);
                var newPos = Math.max(0, caretPos - removed);
                el.setSelectionRange(newPos, newPos);
            }

            if ($el.hasClass('is-invalid')) {
                setPhoneValidity($el, isPhoneValid($el));
            }
        });

        // Final sanitize + validate when focus leaves (catches autofill / paste without input event)
        $phoneField.on('blur', function () {
            var $el = $(this);
            $el.val(sanitize($el.val()));
            setPhoneValidity($el, isPhoneValid($el));
        });

        // Re-validate on submit so the error is visible even if the field was never focused
        $('form.registration').on('login:register', function () {
            $phoneField.val(sanitize($phoneField.val()));
            setPhoneValidity($phoneField, isPhoneValid($phoneField));
        });
    });

    $('body').on('input', '#profile-edit-phone', function () {
        var $el = $(this);
        var el = this;
        var caretPos = el.selectionStart;
        var before = $el.val();
        var after = sanitize(before);

        if (before !== after) {
            var removed = before.length - after.length;
            $el.val(after);
            var newPos = Math.max(0, caretPos - removed);
            el.setSelectionRange(newPos, newPos);
        }

        if ($el.hasClass('is-invalid')) {
            var valid = isPhoneValid($el);
            $el.toggleClass('is-invalid', !valid);
            var errorId = $el.attr('aria-describedby');
            if (errorId) {
                $('#' + errorId).text(valid ? '' : ($el.data('pattern-mismatch') || ''));
            }
        }
    });

    $('body').on('blur', '#profile-edit-phone', function () {
        var $el = $(this);
        $el.val(sanitize($el.val()));

        var valid = isPhoneValid($el);
        var minLength = Number($el.attr('minlength'));
        var maxLength = Number($el.attr('maxlength'));
        var digitCount = $el.val().replace(/\D/g, '').length;
        var hasLengthError = digitCount > 0
            && ((minLength && digitCount < minLength)
                || (maxLength && digitCount > maxLength));

        $el.toggleClass('is-invalid', !valid);
        var errorId = $el.attr('aria-describedby');
        if (hasLengthError && errorId && $el.attr('data-range-error')) {
            $('#' + errorId).text($el.attr('data-range-error') || '');
        } else if (errorId) {
            $('#' + errorId).text(valid ? '' : ($el.data('pattern-mismatch') || ''));
        }
    });

    // When the edit-contact form is injected via AJAX, auto-prepend '+' on the
    // pre-populated phone value (org EditContact strips '+' before setting form value)
    $('body').on('initFloatLabels', function () {
        var $el = $('#profile-edit-phone');
        if ($el.length && $el.val()) {
            $el.val(sanitize($el.val()));
        }
    });
}(jQuery));